module.exports = __webpack_public_path__ + "static/img/znhgc.1365467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/znhgc.png
// module id = HO9k
// module chunks = 0